import { Storage as AWSStorage } from "aws-amplify";
import { BUCKET_NAME } from "App";
import Compressor from "compressorjs";
import { API } from "aws-amplify";

export const isImageFile = (fileName: string) => {
  return (
    fileName.includes("jpg") ||
    fileName.includes("png") ||
    fileName.includes("jpeg")
  );
};
export const getImageUrl = async (location: string): Promise<string> => {
  const url = await AWSStorage.get(location, {
    bucket: BUCKET_NAME,
  });
  return url;
};

export const uploadFile = async (
  location: string,
  body: File,
  onProgress: (progress: any) => void,
  onError: (error: any) => void
) => {
  await AWSStorage.put(location, body, {
    bucket: BUCKET_NAME,
    progressCallback: onProgress,
  });
};

export const uploadImage = async (
  location: string,
  body: File,
  onProgress: (progress: any) => void,
  onError: (error: any) => void
): Promise<void> =>
  new Promise((resolve, reject) => {
    new Compressor(body, {
      quality: 0.7,
      success(result) {
        AWSStorage.put(location, result, {
          bucket: BUCKET_NAME,
          progressCallback: onProgress,
          errorCallback: onError,
        })
          .then(() => {
            resolve();
          })
          .catch(() => {
            alert("Could not upload image");
            reject();
          });
      },
      error(err) {
        alert("Could not upload image");
        reject();
      },
    });
  });

export const downloadBlob = (blob: Blob, filename: string) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || "download.txt";
  const clickHandler = () => {
    setTimeout(() => {
      URL.revokeObjectURL(url);
      a.removeEventListener("click", clickHandler);
    }, 150);
  };
  a.addEventListener("click", clickHandler, false);
  a.click();
  return a;
};

interface BucketConfig {
  [key: string]: string | number | true;
}

export const downloadFile = async (
  location: string,
  downloadName: string,
  onProgress?: (progress: string) => void
) => {
  const config: BucketConfig = {
    download: true,
    cacheControl: "max-age=120",
  };
  const r = (await AWSStorage.get(location, {
    ...config,
    progressCallback: onProgress,
  })) as unknown as {
    Body: Blob;
  };
  downloadBlob(r.Body, downloadName);
};

type FileZipperResponse = {
  data: {
    presignedUrl: string;
  };
};

export const postZipMessageData = async (keys: string[]): Promise<string> => {
  const zipRequest = {
    body: {
      documents: keys,
    },
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
  };
  const res = (await API.post(
    "api",
    "fileZipper",
    zipRequest
  )) as FileZipperResponse;
  return res.data.presignedUrl;
};

export const bulkDownload = async (
  keys: string[],
  onProgress?: (progress: string) => void
) => {
  const presignedUrl = await postZipMessageData(keys);
  await downloadFile(presignedUrl, "archive.zip");
};
